<div id="icons" class="page-layout simple tabbed" fxLayout="column">
    <!-- CONTENT -->
    <div class="content p-24">
        <div>
            <div fxLayout="column">
                <div fxLayout="row wrap">
                    <a routerLink="/reports">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">account_balance</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Selling report'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/new-customers">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">person_filled</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'New customers report'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/first-sale">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">attach_money</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'First sale report'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/receipt-errors">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">sd_card_alert</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Receipt errors report'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/multi-sport">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">rowing</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Multi Sport'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/medicover">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">local_hospital</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Medicover'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/pzu-sport">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">rowing</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'PZU Sport'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/profit">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">rowing</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'ProFit'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/work-time">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">alarm_on</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Work time'|translate}}
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/vouchers-report">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">attach_money</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                Raport sprzedanych karnetów
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/services-use">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">assessment</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                Raport wykonanych usług
                            </div>
                        </div>
                    </a>
                    <a routerLink="/reports/training-commission">
                        <div class="icon-holder m-16" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="secondary-text s-48">payments</mat-icon>
                            <div class="icon-name secondary-text mt-8">
                                {{'Training Commission'|translate}}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
